export const stopPropagationWrapper =
  (fn: (event: React.SyntheticEvent) => void) =>
  (event: React.SyntheticEvent) => {
    event.stopPropagation();
    fn(event);
  };
